const fundsTable = {
  columns: {
    getColumnsData: 'fundsColumnsData',
    setColumnsData: 'setFundsColumnsData'
  },
  rows: {
    getRowsData: 'fundsRowsData',
    setRowsData: 'setFundsRowsData'
  }
}

const fundsTableColumns = [
  {
    id: 1,
    title: 'FUNDS',
    property: 'name'
  },
  {
    id: 2,
    title: 'PERCENT',
    type: 'percent',
    property: 'percent'
  },
  {
    id: 3,
    title: 'CURRENT MONTH',
    property: 'currentMonthBalance'
  },
  {
    id: 4,
    title: 'LAST MONTH BALANCE',
    property: 'lastMonthBalance'
  },
  {
    id: 5,
    title: 'TOTAL',
    calc: {
      lastMonthBalance: '+',
      currentMonthBalance: '+'
    }
  },
  {
    id: 6,
    title: 'PAID',
    property: 'paid'
  },
  {
    id: 7,
    title: 'REMAIN',
    calc: {
      lastMonthBalance: '+',
      currentMonthBalance: '+',
      paid: '-'
    }
  },
  {
    id: 8,
    typeTable: 'funds',
    property: 'action',
    actions: {
      edit: true,
      delete: true
    },
    toolbar: {
      hideEditBtn: false,
      hideDeleteBtn: false
    }
  }
]

export {fundsTable, fundsTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/fundsTable.js